/* eslint-disable max-len */
export const FlyersPage = "/gazetki";
export const FlyerDetails = { url: "/gazetki/%7BbrandSeoName%7D/%7BdiscountSeoName%7D", type: undefined as { brandSeoName: string | number; discountSeoName: string | number; } };
export const Flyers = { url: "/api/flyers/%7Baction%7D", type: undefined as { action: string | number; } };
